// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".table-data-2-show[data-v-d8f834b0] {\n  padding: 0.53333rem;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  background-color: #FFF;\n  border-radius: 0.26667rem;\n}\n.table-data-2-show .table-data-container[data-v-d8f834b0] {\n  width: 8.4rem;\n  height: 5.33333rem;\n  position: relative;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
